import { useRoute } from "../../../../hooks/useRoute";
import {
  Page,
  Left,
  Right,
  HeaderRow,
  RoleListContainer,
  RoleItem,
  SearchInput,
} from "../styles/component.style";
import { BtnGeneral } from "../../../../styles/Buttons";
import SearchableSelect from "../../../../components/Common/SearchableSelect";

export default function Routes() {
  /* ===================== ROUTES ===================== */
  const {
    routes,
    selectedRoutes,
    handleSelectRoutes,
    saveRoutes,
    handleNew,
    setForm,
    form,
    search,
    setSearch,
  } = useRoute();

  /* ===================== FILTRO ROUTAS ===================== */
  const filteredRoutes = routes.filter(
    (r) =>
      (r.descripcion?.toLowerCase() || "").includes(search.toLowerCase()) ||
      (r.codigo?.toString() || "").includes(search)
  );

  return (
    <Page>
      {/* ================= PANEL IZQUIERDO ================= */}
      <Left>
        <HeaderRow>
          <h3>Rutas</h3>
          <BtnGeneral
            bg="cyan"
            padding="6px 10px"
            radius="6px"
            fw="600"
            onClick={handleNew}
          >
            Nuevo
          </BtnGeneral>
        </HeaderRow>

        <SearchInput
          placeholder="Buscar x Codigo, Descripcíon......"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <RoleListContainer>
          {filteredRoutes.length > 0 ? (
            filteredRoutes.map((r) => (
              <RoleItem
                key={r.id}
                active={selectedRoutes === r.id}
                onClick={() => handleSelectRoutes(r.id)}
              >
                <strong>{r.descripcion}</strong>
                {r.orden !== undefined && r.orden !== null && (
                  <div style={{ fontSize: "11px", color: "#64748b" }}>Orden: {r.orden}</div>
                )}
              </RoleItem>
            ))
          ) : (
            <div style={{ padding: "12px", color: "#94a3b8", textAlign: "center", fontSize: "12px" }}>
              {search ? "No se encontraron rutas" : "No hay rutas registradas"}
            </div>
          )}
        </RoleListContainer>
      </Left>

      {/* ================= PANEL DERECHO ================= */}
      <Right>
        <HeaderRow>
          <h3>{form.id ? "Editar ruta" : "Nueva ruta"}</h3>
          <BtnGeneral
            bg="green"
            padding="6px 10px"
            radius="6px"
            fw="600"
            onClick={saveRoutes}
          >
            Guardar
          </BtnGeneral>
        </HeaderRow>

        <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
          {/* COLUMNA 1 */}
          <div style={{ flex: 1 }}>
            <label>ID</label>
            <input disabled value={form.id} style={inputStyle} />

            <label>Descripcion</label>
            <input
              value={form.descripcion}
              onChange={(e) =>
                setForm({ ...form, descripcion: e.target.value })
              }
              style={inputStyle}
            />

            <label>Orden</label>
            <input
              type="number"
              value={form.orden ?? 0}
              onChange={(e) =>
                setForm({ ...form, orden: e.target.value })
              }
              style={inputStyle}
            />
          </div>

          {/* COLUMNA 2 */}
          <div style={{ flex: 1 }}>
            <label>Codigo</label>
            <input
              value={form.codigo}
              onChange={(e) => setForm({ ...form, codigo: e.target.value })}
              style={inputStyle}
            />
            <label>Estado</label>
            <SearchableSelect
              key={`estado-${form.id || "new"}`}
              value={String(form.estado ?? "1")}
              onValueChange={(val) => setForm({ ...form, estado: val })}
              options={[
                { value: "1", label: "ACTIVO" },
                { value: "0", label: "INACTIVO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "12px", ...selectSx }}
            />
          </div>
        </div>
      </Right>
    </Page>
  );
}

const inputStyle = {
  width: "100%",
  padding: "6px",
  marginBottom: "12px",
  borderRadius: "6px",
  border: "1px solid #cbd5e1",
};

const selectSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
    backgroundColor: "#ffffff",
    "& fieldset": { borderColor: "#cbd5e1" },
    "&:hover fieldset": { borderColor: "#94a3b8" },
    "&.Mui-focused fieldset": { borderColor: "#007bba" },
  },
  "& .MuiSelect-select": {
    padding: "6px 10px !important",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
  },
};
